import React from 'react';
import '../styling/componentStyles.css';
import { phoneIcon as PhoneIcon } from './../assets/icons/phoneIcon';

export const Label: React.FC = () =>{
    
        return (
            <div className='footer'>
                <div className='leftText'>&copy;{new Date().getFullYear()} Pidilite Industries Ltd.</div>
                <div className='rightText customer_care'><a href="tel:18002666662">
                    <PhoneIcon />
                    Contact Us</a></div>
            </div>
        )
    }

export default Label